import {ColorCodesEnum, ComponentTypesEnum} from 'appShared/enums';
import {
    BaseControl,
    DatepickerControl,
    RadioGroupControl,
    SelectControl
} from 'appShared/classes';
import {
    AccountPlanStatusEnum,
    ReportColumnNames,
    TradingAccountDetailedReportModel
} from '@spa/api';
import {Validators} from '@angular/forms';
import {RadioGroupOptionInterface} from 'appShared/components';
import {Helper} from 'appShared/classes';
import {FilterControlInterface} from 'appShared/interfaces';
import * as moment from 'moment/moment';
import {
    PanelReportsFilterCurrencySelector,
    PanelReportsFilterDateFromSelector,
    PanelReportsFilterDateSelector,
    PanelReportsFilterDateToSelector
} from 'appAssets/descriptors';
import {DataHeader, IDataTable} from '@spa/reporting';

export const EditAccountTraderSelector = 'editAccountTrader';
export const EditAccountDisplayNameSelector = 'editAccountDisplayName';
export const EditAccountIntradayLeverageSelector = 'editAccountIntradayLeverege';
export const EditAccountONLeverageSelector = 'editAccountIntradayLeverege';
export const EditAccountClearingAgentSelector = 'editAccountIntradayLeverege';
export const EditAccountClearingAccountIdSelector = 'editAccountClearingAccountId';

export const PanelAccountsEditAccountControls = (): BaseControl[] => {
    return [
        new BaseControl({
            name: EditAccountTraderSelector,
            value: null,
            placeholder: 'Manager/Trader',
            validators: [],
            componentType: ComponentTypesEnum.Text,
        }),
        new BaseControl({
            name: EditAccountDisplayNameSelector,
            value: null,
            placeholder: 'Display Name',
            validators: [],
            componentType: ComponentTypesEnum.Text,
        }),
        new SelectControl({
            name: EditAccountIntradayLeverageSelector,
            value: null,
            placeholder: 'Intraday Leverage',
            validators: [],
            componentType: ComponentTypesEnum.Select,
            options: []
        }),
        new SelectControl({
            name: EditAccountONLeverageSelector,
            value: null,
            placeholder: 'O/N Leverage',
            validators: [],
            componentType: ComponentTypesEnum.Select,
            options: []
        }),
        new SelectControl({
            name: EditAccountClearingAgentSelector,
            value: null,
            placeholder: 'Clearing Agent',
            validators: [],
            componentType: ComponentTypesEnum.Select,
            options: []
        }),
        new SelectControl({
            name: EditAccountClearingAccountIdSelector,
            value: null,
            placeholder: 'Clearing Account ID',
            validators: [],
            componentType: ComponentTypesEnum.Select,
            options: []
        }),
    ];
};


export const AccountPlanStatusesControl = (): RadioGroupControl => {
    return new RadioGroupControl({
        name: TradingAccountDetailedReportModel.getAccountTradingPlanStatusSelector(),
        value: null,
        placeholder: 'Status',
        validators: [
            Validators.required
        ],
        componentType: ComponentTypesEnum.RadioGroup,
        invalid: false,
        errors: [],
        options: []
    });
};
export const AccountPlanStatusControlOptions = (): RadioGroupOptionInterface[] => {
    return [
        {
            label: Helper.textsHelper().getAccountPlanStatusName(
                AccountPlanStatusEnum.InProgress
            ),
            value: AccountPlanStatusEnum.InProgress,
            color: ColorCodesEnum.Primary
        },
        {
            label: Helper.textsHelper().getAccountPlanStatusName(
                AccountPlanStatusEnum.Successful
            ),
            value: AccountPlanStatusEnum.Successful,
            color: ColorCodesEnum.Primary
        },
        {
            label: Helper.textsHelper().getAccountPlanStatusName(
                AccountPlanStatusEnum.Failed
            ),
            value: AccountPlanStatusEnum.Failed,
            color: ColorCodesEnum.Primary
        },
        {
            label: Helper.textsHelper().getAccountPlanStatusName(
                AccountPlanStatusEnum.Rejected
            ),
            value: AccountPlanStatusEnum.Rejected,
            color: ColorCodesEnum.Primary
        }
    ];
};

export const PanelAccountPlanTradesFilterControls = (): FilterControlInterface[] => {
    const controls = [
        {
            name: PanelReportsFilterDateSelector,
            placeholder: 'Date',
            controls: [
                new DatepickerControl({
                    name: PanelReportsFilterDateFromSelector,
                    value: null,
                    placeholder: 'Date from',
                    maxDate: moment().format('YYYY-MM-DD'),
                    validators: [Validators.required],
                    componentType: ComponentTypesEnum.Datepicker,
                    sortIndex: 1
                }),
                new DatepickerControl({
                    name: PanelReportsFilterDateToSelector,
                    value: null,
                    placeholder: 'Date to',
                    maxDate: moment().format('YYYY-MM-DD'),
                    validators: [Validators.required],
                    componentType: ComponentTypesEnum.Datepicker,
                    sortIndex: 2
                }),
            ],
            shown: true,
            sortIndex: 2
        },
        {
            name: PanelReportsFilterCurrencySelector,
            placeholder: 'Currency',
            controls: [
                new SelectControl({
                    name: PanelReportsFilterCurrencySelector,
                    value: null,
                    placeholder: 'Currency',
                    validators: [Validators.required],
                    componentType: ComponentTypesEnum.Select,
                    options: []
                }),
            ],
            shown: true,
            sortIndex: 5
        },

    ];

    return controls;
};


export const TradesReportTableConfig = (): IDataTable => {
    return {
        rows: [],
        columns: [
            new DataHeader({
                label: 'Opened',
                selector: ReportColumnNames.Date,
            }),
            new DataHeader({
                label: 'Closed',
                selector: ReportColumnNames.Closed,
            }),
            new DataHeader({
                label: 'Held',
                selector: ReportColumnNames.Held,
            }),
            new DataHeader({
                label: 'Symbol',
                selector: ReportColumnNames.Symbol,
            }),
            new DataHeader({
                label: 'Type',
                selector: ReportColumnNames.Type,
            }),
            new DataHeader({
                label: 'Entry',
                selector: ReportColumnNames.Entry,
                shifted: true
            }),
            new DataHeader({
                label: 'Exit',
                selector: ReportColumnNames.Exit,
                shifted: true
            }),
            new DataHeader({
                label: 'Qty',
                selector: ReportColumnNames.Qty,
                shifted: true
            }),
            new DataHeader({
                label: 'Gross',
                selector: ReportColumnNames.Gross,
                shifted: true
            })
        ],
        hiddenColumnIds: [],
        disableColumnsOptions: true
    };
};
